export default "__VITE_PUBLIC_ASSET__dbb2d760__"